
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import styled from 'styled-components';
import ROUTES from 'config/routes';
import NextLinkButton from 'shared/components/NextLinkButton';
import Page from 'shared/components/Page';
import useTranslation from 'shared/hooks/useTranslation';
import Head from 'next/head';
import NextImage from 'next/image';
const ErrorWrapper = styled.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 6.4rem 3.2rem;
  width: 100%;

  ${({ theme }) => theme.MEDIA.SM} {
    box-shadow: ${({ theme }) => theme.SHADOWS.PRIMARY};
    margin: 12.8rem auto;
    padding: 6.4rem 12.8rem;
    width: fit-content;
  }
`;
const Header = styled.div `
  display: flex;
  justify-content: center;
  padding-bottom: 3.2rem;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.PRIMARY_RGB};
  width: 20rem;

  ${({ theme }) => theme.MEDIA.SM} {
    width: 41rem;
    height: auto;
  }
`;
const Logo = styled.div `
  position: relative;

  ${({ theme }) => theme.MEDIA.SM} {
    min-width: 100%;
    height: auto;
  }

  img {
    height: auto;
    width: 100%;
  }
`;
const Text = styled.h1 `
  font-size: 2rem;
  text-align: center;
  padding-top: 3.2rem;

  ${({ theme }) => theme.MEDIA.SM} {
    font-size: 2.4rem;
  }
`;
const GoBackLinkButton = styled(NextLinkButton) `
  line-height: 1.65;
  margin-left: 3.2rem;
  padding: 1.6rem 3.2rem;
  margin: 3.2rem 0;
`;
function Page404(): JSX.Element {
    const { t } = useTranslation('common');
    return (<Page>
      <Head>
        <title>{t('titleTag')}</title>
      </Head>
      <main>
        <ErrorWrapper>
          <Header>
            <Logo>
              <NextImage width={410} height={87} src="/img/logos/logo-trustmate-2022-light.svg" alt="logo"/>
            </Logo>
          </Header>
          <Text>{t('errorBoundary.errorOccured')} 404</Text>
          <GoBackLinkButton href={ROUTES.HOME}>{t('errorBoundary.goToHomePage')}</GoBackLinkButton>
        </ErrorWrapper>
      </main>
    </Page>);
}
const getStaticProps: GetStaticProps = async () => ({ props: {} });
export default Page404;

    async function __Next_Translate__getStaticProps__196e8922150__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/404',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196e8922150__ as getStaticProps }
  